var isKeyable = require('./_isKeyable');

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;



//////////////////
// WEBPACK FOOTER
// ./~/lodash/_getMapData.js
// module id = ./node_modules/lodash/_getMapData.js
// module chunks = 11056403903869698000